
import React from 'react';
import { TrendingUp, Users, CheckCircle, ArrowUpRight } from 'lucide-react';

const FounderStory: React.FC = () => {
  return (
    <section className="py-24 bg-[#F4E4C1] text-[#0F1419] border-y border-[#4E3629]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center gap-16">
          <div className="flex-1 order-2 md:order-1">
            <span className="text-[#1A4D2E] font-black uppercase tracking-widest text-sm mb-4 block">Field-Tested & Built in the Bucket</span>
            <h2 className="text-4xl md:text-7xl font-black mb-8 leading-[0.85] uppercase italic tracking-tighter">
              Partnership <br />Over Software.
            </h2>
            <div className="space-y-6 text-xl text-[#4E3629] leading-relaxed font-bold">
              <p>
                After 6 years running crews and scaling to 7 figures, I learned the hard way: the money isn't in doing great work. <span className="text-[#1A4D2E] underline decoration-[#FF6B35] decoration-4">The money is in the FOLLOW-UP.</span> 
              </p>
              <p>
                But here's the thing—most tree guys don't need another app. They need someone who's been in their boots, knows their problems, and will actually help them implement.
              </p>
              <p>
                That's why Arbor Advantage isn't just software. It's coaching, systems, and accountability from someone who's scaled a tree service to <span className="bg-[#FF6B35] text-white px-2 italic font-black text-2xl">$100K+/month</span> and helped 200+ others do the same.
              </p>
              <p className="text-2xl font-black text-[#0F1419] italic underline decoration-[#1A4D2E] decoration-4 mt-8">
                You're not buying a subscription. You're getting a partner who only wins when you win.
              </p>
            </div>
          </div>
          <div className="flex-1 order-1 md:order-2">
            <div className="relative group w-full">
              <div className="absolute -inset-4 bg-[#4E3629] rounded-[2.5rem] rotate-3 opacity-10 group-hover:rotate-0 transition-transform duration-700" />
              
              {/* Visual Replacement: Data/Metric Dashboard */}
              <div className="relative rounded-[2.5rem] shadow-2xl overflow-hidden border-4 border-[#4E3629] bg-[#0F1419] p-8 md:p-12 flex flex-col gap-8">
                <div className="flex items-center justify-between border-b border-white/10 pb-6">
                  <div className="flex items-center gap-3">
                    <TrendingUp className="w-8 h-8 text-[#FF6B35]" />
                    <h4 className="text-white font-black uppercase italic tracking-tighter text-xl">Operational Lift</h4>
                  </div>
                  <ArrowUpRight className="text-[#1A4D2E] w-6 h-6" />
                </div>

                <div className="grid grid-cols-2 gap-6">
                  <div className="bg-white/5 p-6 rounded-2xl border border-white/10">
                    <p className="text-[#F4E4C1]/50 text-[10px] font-black uppercase tracking-widest mb-1">Pipeline Growth</p>
                    <p className="text-3xl font-black text-[#FF6B35]">+214%</p>
                  </div>
                  <div className="bg-white/5 p-6 rounded-2xl border border-white/10">
                    <p className="text-[#F4E4C1]/50 text-[10px] font-black uppercase tracking-widest mb-1">Time Saved</p>
                    <p className="text-3xl font-black text-[#1A4D2E]">18hr/wk</p>
                  </div>
                </div>

                <div className="bg-[#1A4D2E]/20 p-6 rounded-2xl border-2 border-[#1A4D2E]/40">
                  <div className="flex items-center gap-3 mb-4">
                    <Users className="w-5 h-5 text-[#1A4D2E]" />
                    <span className="text-white font-black uppercase text-xs">Community Wins</span>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-center gap-2 text-[10px] font-bold text-gray-400">
                      <CheckCircle className="w-3 h-3 text-[#FF6B35]" /> $42,500 Quote Accepted (3m ago)
                    </div>
                    <div className="h-1 bg-white/5 rounded-full overflow-hidden">
                      <div className="w-3/4 h-full bg-[#1A4D2E]" />
                    </div>
                  </div>
                </div>

                <div className="absolute top-0 right-0 p-8 opacity-5 pointer-events-none">
                  <TrendingUp className="w-64 h-64 text-white" />
                </div>
              </div>
              
              <div className="absolute -bottom-10 -right-6 bg-white p-6 rounded-2xl shadow-2xl border-4 border-[#1A4D2E] max-w-[280px] z-20">
                <p className="text-sm font-black text-[#1A4D2E] uppercase mb-1 italic">Scaling Playbook</p>
                <p className="text-xs font-bold text-[#4E3629]">I went from solo climber to 7-figure owner using these exact systems. Now they are yours.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStory;
